export enum EOnHandDeliveryStatus {
    exceptionEntry = 1,
    inProgress = 13,
    followupInProgress = 14,
    srpendingpproval = 10,
    needsCleared = 12,
    creditHold = 18,
  }
  